var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SSelect',{attrs:{"label":_vm.label,"source":_vm.options,"resultsDisplay":"label","resultsValue":"label","autocomplete":false},on:{"selected":_vm.input,"clear":function($event){return _vm.clear($event)}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }